'use client'

import { useTranslations } from 'next-intl'
import { MessageSquareText } from 'lucide-react'
import { Accordion, AccordionItem } from '@/components/ui/accordion'

interface FAQPageContentProps {
  faqs: Array<{ question: string; answer: string }>
}

export function FAQPageContent({ faqs }: FAQPageContentProps) {
  const t = useTranslations('booking.about')

  return (
    <div className="min-h-[60vh]">
      <section className="relative bg-gradient-to-br from-primary/5 via-white to-accent/5 dark:from-primary/10 dark:via-gray-900 dark:to-accent/10 border-b border-gray-100 dark:border-gray-800">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14 text-center">
          <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-4">
            <MessageSquareText className="h-6 w-6 text-primary" />
          </div>
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 dark:text-gray-100 tracking-tight">
            {t('faq')}
          </h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <Accordion className="space-y-3">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={faq.question}
              defaultOpen={false}
              className="bg-white dark:bg-gray-800 rounded-xl border-gray-100 dark:border-gray-700 overflow-hidden"
            >
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                {faq.answer}
              </p>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  )
}
